module.exports = __webpack_public_path__ + "img/technology.ab076a08.svg";